import PropTypes from 'prop-types';
import React from 'react';

const PlusIcon = ({ className, isMinus }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d={isMinus ? 'M5 12h14' : 'M12 4.5v15m7.5-7.5h-15'}
    />
  </svg>
);

PlusIcon.propTypes = {
  className: PropTypes.string,
  isMinus: PropTypes.bool,
};

PlusIcon.defaultProps = {
  className: '',
  isMinus: false,
};

export default PlusIcon;
